import * as React from 'react';
import { memo } from 'react';

import { FavoriteTeaserProductProps } from 'components/molecules/Favorite/TeaserProduct';
import FavoriteTeaserProduct from 'containers/molecules/Favorite/TeaserProduct';

export type FavoriteListPropsType = {
	items?: FavoriteTeaserProductProps[];
};

export class FavoriteList extends React.Component<FavoriteListPropsType> {
	public static displayName = 'FavoriteList';
	public static defaultValues = {};

	public render() {
		return (
			<ul className="m-favorite-list">
				{(this.props.items || ([] as any[])).map((item: FavoriteTeaserProductProps, index: number) => {
					return (
						<li key={`.${item.productId}#${index}`} className="m-favorite-list__item">
							<div className="col-xs-6 col-sm-6 col-md-3">
								<FavoriteTeaserProduct
									productId={item.productId!}
									favorite={item.favorite!}
									decorator={item.decorator!}
								/>
							</div>
						</li>
					);
				})}
			</ul>
		);
	}
}

export default memo(FavoriteList);
